import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useFetchPromise } from '@rad/hooks';
import { getJson } from '@rad/utility/http';
import Card from '../components/card';
export default () => {
    const [keys] = useFetchPromise(getJson('/subscription-keys'));
    // export default {
    //   'data':() => ({
    //     'raw':{
    //       'keys':null,
    //     },
    //   }),
    //   async 'mounted'(){
    //     await Promise.all([
    //       this.loadSubscriptionKeys(),
    //     ])
    //   },
    //   'methods':{
    //     async 'loadSubscriptionKeys'(){
    //       this.raw.keys = await
    //     },
    //   },
    // }
    return _jsx(_Fragment, { children: _jsx("div", { className: "d-flex w-100", children: _jsx("div", { className: "column-2", children: _jsx(Card, { table: true, title: "Subscription Keys", children: _jsxs("table", { className: "table table-sm table-striped", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Key" }), _jsx("th", { children: "Used By" })] }) }), _jsx("tbody", { children: keys === null || keys === void 0 ? void 0 : keys.map((key) => _jsxs("tr", { children: [_jsx("td", { children: key.key }), key.iso_id ? _jsx("td", { children: _jsxs("a", { href: `#/admin/isos/${key.iso_id}`, children: [key.iso_name, " (", key.merchant_name, ")"] }) }) : _jsx("td", {})] })) })] }) }) }) }) });
};
